import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as R from 'ramda'

import { deleteJobs } from 'ducks/concurrency'
import { useModal, useSnackbar } from 'hooks'

const useDeleteJobsModalMutations = () => {
  const dispatch = useDispatch()

  const handleDeleteJobs = React.useCallback(
    ({ onShowSnackbar }) => {
      dispatch(deleteJobs(onShowSnackbar))
    },
    [dispatch],
  )

  return {
    handleDeleteJobs,
  }
}

export const useDeleteJobsModalState = () => {
  const { projects } = useSelector(state => state.orm)

  const pks = R.keys(projects?.meta?.selected) || []

  const count = R.length(pks)

  const jobs = R.filter(
    ({ id }) => R.includes(id?.toString(), pks),
    R.values(projects?.items),
  )

  return {
    state: {
      count,
      jobs,
      pks,
    },
  }
}

export const useDeleteJobsModal = () => {
  const { isOpen, handleClose, handleOpen } = useModal()

  const {
    handlers: { handleShowSnackbar },
  } = useSnackbar()

  const { handleDeleteJobs } = useDeleteJobsModalMutations()

  const handleConfirm = React.useCallback(() => {
    handleDeleteJobs({ onShowSnackbar: handleShowSnackbar })
    handleClose()
  }, [handleClose, handleDeleteJobs, handleShowSnackbar])

  return {
    handleDeleteJobsModalClose: handleClose,
    handleDeleteJobsModalConfirm: handleConfirm,
    handleDeleteJobsModalOpen: handleOpen,
    isDeleteJobsModalOpen: isOpen,
  }
}
